import React from 'react';

const nombreLunch = (s) => {
  const base = (s && s.menu_vinculado_nombre) || 'el lunch';
  return s && s.jornada_etiqueta ? `${base} (${s.jornada_etiqueta})` : base;
};

const textoMinutos = (min) => {
  const n = Math.max(0, Number(min) || 0);
  const h = Math.floor(n / 60);
  const m = n % 60;
  if (h === 0) return `${m} min`;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
};

const boton = 'px-2.5 py-1 text-xs font-medium bg-white border rounded-md disabled:opacity-50';

/**
 * Hora extra del lunch (más de 1 h 30), por lunch y jornada. La línea en sí
 * sale con el resto de suplementos (se edita, regala y quita como ellos); aquí
 * solo lo que no tiene línea, en una fila compacta cada uno:
 * - Pendientes (presupuesto enviado o confirmado, o hora extra puesta a mano):
 *   Añadir y Regalar.
 * - Quitadas a mano: Volver a añadir.
 *
 * @param {object} props
 * @param {object} props.estado bloque `hora_extra_lunch` del estado de reglas
 * @param {string|null} props.enCurso acción en curso (`hora_extra:accion:clave`) o null
 * @param {(accion: string, clave?: string) => void} props.onAccion
 * @param {(n: number) => string} props.formatEuros
 */
export default function HoraExtraLunchAviso({ estado, enCurso, onAccion, formatEuros }) {
  if (!estado) return null;
  const pendientes = estado.pendientes || [];
  const quitadas = estado.quitadas || [];
  if (pendientes.length === 0 && quitadas.length === 0) return null;
  const ocupado = !!enCurso;
  const texto = (accion, clave, normal, enMarcha) => (enCurso === `hora_extra:${accion}:${clave || ''}` ? enMarcha : normal);
  const manual = estado.manual_sin_marca || [];

  return (
    <div className="space-y-1" data-testid="aviso-hora-extra-lunch">
      {pendientes.map((s) => (
        <div key={s.clave} className="flex flex-wrap items-center gap-2 px-3 py-1.5 rounded-lg border bg-amber-50 border-amber-300 text-xs text-amber-900">
          <span className="flex-1 min-w-[220px]">
            <span className="font-semibold">Falta la hora extra de {nombreLunch(s)}:</span>{' '}
            termina a las {s.hora_fin}, {textoMinutos(s.minutos_extra)} más de la hora y media, {formatEuros(s.importe)}
            {manual.length > 0 ? ` (revisa la puesta a mano: ${manual.join(', ')})` : ''}
          </span>
          <button type="button" disabled={ocupado} onClick={() => onAccion('anadir', s.clave)}
            className="px-2.5 py-1 text-xs font-medium bg-amber-600 text-white rounded-md hover:bg-amber-700 disabled:opacity-50">
            {texto('anadir', s.clave, 'Añadir', 'Añadiendo...')}
          </button>
          <button type="button" disabled={ocupado} onClick={() => onAccion('regalar', s.clave)}
            className={`${boton} border-amber-400 text-amber-800 hover:bg-amber-100`}>
            {texto('regalar', s.clave, 'Regalar', 'Guardando...')}
          </button>
        </div>
      ))}
      {quitadas.map((s) => (
        <div key={s.clave} className="flex flex-wrap items-center gap-2 px-3 py-1.5 rounded-lg border bg-gray-50 border-gray-200 text-xs text-gray-600">
          <span className="flex-1 min-w-[220px]">
            Quitada a mano: hora extra de {nombreLunch(s)} (termina a las {s.hora_fin}, {formatEuros(s.importe)}).
          </span>
          <button type="button" disabled={ocupado} onClick={() => onAccion('volver_a_anadir', s.clave)}
            className={`${boton} border-gray-300 text-gray-700 hover:bg-white`}>
            {texto('volver_a_anadir', s.clave, 'Volver a añadir', 'Añadiendo...')}
          </button>
        </div>
      ))}
    </div>
  );
}
